// extracted by css-extract-rspack-plugin
export default {"header":"header-JXcdOU","headerText":"headerText-evIEHb","footer":"footer-eVPCr1"};